// extracted by mini-css-extract-plugin
export default {"mainContainer":"Product_mainContainer__fhM46"};